module.exports = __webpack_public_path__ + "static/img/iPhone13.d045468.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iPhone13.png
// module id = AzPa
// module chunks = 52